import React from 'react';

const InputLabel = ({ htmlFor, children, className, ...rest }) => (
  <label className={ `uk-form-label input-label icon-text ${ className }` } htmlFor={ htmlFor } { ...rest }>{ children }</label>
);

export default InputLabel;
